module.exports = __webpack_public_path__ + "media/images/components/c01-page-header/wave--lg-78fc6b016fda3d94fb0107598e65f49e.svg";